var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormFieldDropdown',{attrs:{"label":_vm.$t('Produkt auswählen') ?? '',"variant":_vm.variant,"value":_vm.selectedProduct,"items":_vm.availableProducts,"disableDelete":"","slimMargin":"","positionFixed":false},on:{"update":(value) => _vm.$emit('update:selectedProduct', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }